module.exports = __webpack_public_path__ + "img/rwsuccess.1859210f.svg";